/* eslint-disable react/jsx-no-useless-fragment */
import PropTypes from 'prop-types';
import { withTranslator } from '../../../I18n/withTranslator';
// import { Helmet } from 'react-helmet';
import { Col, Container, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import ExternalProviderContainer from '../ByExternalProvider/ExternalProviderContainer';
import { RETURN_URL_LOGIN } from '../ByExternalProvider/LoginReturnUrls';
import AuthLoginByEmailAndPasswordForm from './AuthLoginByEmailAndPasswordForm';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AuthLoginByEmailAndPasswordComponent = ({
  t,
  login,
  loading,
  isLoggedIn,
  userDataOnDemand,
  redirectToPathAfterSuccess,
  icons,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  displayRegisterButton,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(redirectToPathAfterSuccess);
    }
  }, [isLoggedIn, navigate, redirectToPathAfterSuccess]);

  return (
    <>
      {!isLoggedIn && (
        <div>
          {/* TODO: React Helmet */}
          {/* <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet> */}
          <section className="bg-white full-height">
            <Container className="py-5">
              <h1 className="text-center title-medium semi-bold">{t('auth/login/title')}</h1>
              <Row>
                <Col xs="12" sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 3 }}>
                  <AuthLoginByEmailAndPasswordForm
                    login={login}
                    loading={loading}
                    userDataOnDemand={userDataOnDemand}
                    redirectToPathAfterSuccess={redirectToPathAfterSuccess}
                    icons={icons}
                  />
                  <div className="line">
                    <span>{t('auth/login/login-with-socials')}</span>
                  </div>
                  <ExternalProviderContainer
                    returnUrl={RETURN_URL_LOGIN}
                    roundedBtn
                    displayAppleButton={displayAppleButton}
                    displayFacebookButton={displayFacebookButton}
                    displayGoogleButton={displayGoogleButton}
                  />
                </Col>
              </Row>
              {displayRegisterButton && (
                <p className="small mt-3 mb-5 text-center">
                  {t('auth/login/no-account-question')}{' '}
                  <Link to={'/auth/register'}>{t('auth/login/register-btn-text')}</Link>
                </p>
              )}
            </Container>
          </section>
        </div>
      )}
    </>
  );
};

AuthLoginByEmailAndPasswordComponent.propTypes = {
  t: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  userDataOnDemand: PropTypes.func.isRequired,
  redirectToPathAfterSuccess: PropTypes.string.isRequired,
};

export default withTranslator(AuthLoginByEmailAndPasswordComponent);
